import {
  Box,
  Button,
  Input,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  ValidationMessage,
} from '@modusign/design-system';
import { useDocument } from '@modusign/react-signing';
import { useState } from 'react';

import { validateTitle } from '@app/libs/validation';

interface TemplateCopySaveModalProps {
  onClickCancel: () => void;
  onClickSave: (title: string) => void;
}

export default function TemplateCopySaveModal({
  onClickCancel,
  onClickSave,
}: TemplateCopySaveModalProps) {
  const { document } = useDocument();

  const [titleInModal, setTitleInModal] = useState(`${document.title}의 사본`);
  const [error, setError] = useState('');

  const validateTemplateTitle = (title: string) => {
    const { message } = validateTitle(title, { maxLength: 100, minLength: 2, name: '템플릿 이름' });
    setError(message);
  };

  const handleChangeTitle = (title: string) => {
    setTitleInModal(title);
    validateTemplateTitle(title || '');
  };

  const handleClickCopySave = () => {
    onClickSave(titleInModal);
  };

  return (
    <Modal isOpen maxWidth="xs" onClose={onClickCancel}>
      <ModalTitle>템플릿 저장</ModalTitle>
      <ModalContent>
        <Box as="p" mb={0} textAlign="center">
          사본으로 저장할 템플릿에 이름을 입력해 주세요.
        </Box>
        <br />
        <Input
          id="templateName"
          isInvalid={!!error}
          placeholder="2자 이상 100자 이하로 입력해주세요."
          value={titleInModal}
          width="350px"
          onChange={(event) => {
            handleChangeTitle(event.target.value);
          }}
        />
        {error && <ValidationMessage>{error}</ValidationMessage>}
      </ModalContent>
      <ModalFooter>
        <Button mr={2} onClick={onClickCancel}>
          취소
        </Button>
        <Button
          disabled={!!error}
          ml={2}
          variant="primary"
          width="regular"
          onClick={handleClickCopySave}
        >
          사본으로 저장
        </Button>
      </ModalFooter>
    </Modal>
  );
}
